/*
  "Your browsing history".

  Every product page adds itself to a short list kept in the browser, so the
  row can be drawn straight away with no waiting on the shop. Nothing leaves
  the visitor's own browser.
*/
(function () {
  'use strict';

  var STORE_KEY = 'magnum-browsing-history';
  var MAX_KEPT = 20;

  function read() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(list.slice(0, MAX_KEPT)));
    } catch (e) {
      /* A private window can refuse to store anything - the row just stays empty. */
    }
  }

  function remember(item) {
    if (!item.url || !item.title) return;

    var list = read().filter(function (seen) {
      return seen.url !== item.url;
    });

    list.unshift(item);
    write(list);
  }

  function card(item) {
    /* The link sits inside the slide rather than being it, so a row with only
       one or two products keeps normal sized cards instead of one huge one. */
    var slide = document.createElement('div');
    slide.className = 'swiper-slide';

    var link = document.createElement('a');
    link.className = 'magnum-history__item';
    link.href = item.url;

    var media = document.createElement('span');
    media.className = 'magnum-history__media';

    if (item.image) {
      var img = document.createElement('img');
      img.src = item.image;
      img.alt = '';
      img.loading = 'lazy';
      media.appendChild(img);
    }

    var title = document.createElement('span');
    title.className = 'magnum-history__title';
    title.textContent = item.title;

    link.appendChild(media);
    link.appendChild(title);
    slide.appendChild(link);
    return slide;
  }

  function draw(row) {
    var current = (row.getAttribute('data-product-url') || '').split('?')[0];
    var track = row.querySelector('[data-row-items]');
    var most = parseInt(row.getAttribute('data-products-to-show'), 10) || 10;

    var items = read().filter(function (item) {
      return item.url && item.url.split('?')[0] !== current;
    });

    if (!items.length) return;

    items.slice(0, most).forEach(function (item) {
      track.appendChild(card(item));
    });

    row.classList.add('magnum-row--loaded');

    if (window.MagnumPdpRows) {
      window.MagnumPdpRows.init(row.querySelector('[data-row-slider]'));
    }
  }

  function start() {
    var row = document.querySelector('[data-browsing-history]');

    /*
      The page being looked at goes on the list first, but the row itself
      leaves it out - nobody needs a link back to where they already are.
    */
    var seed = document.querySelector('[data-history-current]');
    if (seed) {
      remember({
        url: seed.getAttribute('data-url'),
        title: seed.getAttribute('data-title'),
        image: seed.getAttribute('data-image')
      });
    }

    if (row) draw(row);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
